// extracted by mini-css-extract-plugin
module.exports = {"worksContainer":"works-module--worksContainer--3zpkD","works":"works-module--works--1h_Re"};